import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { skip, Subscription } from 'rxjs';
import { Page } from './models/page.interface';

@Component({
    standalone: true,
    imports: [CommonModule],
    selector: 'page-base',
    template: ''
})
export class PageBase implements OnDestroy, OnInit {
    page: Page;
    protected subscriptions:Array<Subscription>
    constructor(
        protected _route: ActivatedRoute,
    ) {
        this.subscriptions = [];
        this.page = this._route?.snapshot?.data?.content?.page;
        this.subscriptions.push(this._route.data.pipe(skip(1)).subscribe(data => {
            this.page = data?.content?.page;
            this.ngOnInit();
        }))
    }
    ngOnInit() {}
    ngOnDestroy(): void {
        this.subscriptions.forEach(s => {
            if(s != null && !s.closed)
            s.unsubscribe();
        })
    }
}
